import * as React from "react";
import { Container, Paper } from "@mui/material";
import { Posts } from "../";
import { LinkProps } from "../../common/types";
import PostData from "../../data/Posts";
import { Helmet } from "react-helmet-async";
import { canonicalUrl } from "../../common/seo";

interface Props {
  linkObject: LinkProps;
}

export function Page(props: Props) {
  const filteredPosts = PostData.filter((post) => {
    const linkText = props.linkObject.text.toLowerCase();
    return post.tags.includes(linkText) || linkText === "home";
  });

  const pathname = props.linkObject.link;
  const title =
    props.linkObject.text === "Home"
      ? "NWA Blog | Food, Trails, and Fishing in Northwest Arkansas"
      : `${props.linkObject.text} | NWA Blog`;
  const description =
    props.linkObject.text === "Home"
      ? "Northwest Arkansas blog for the best spots for food, trails, and cycling—photos and quick reviews."
      : `Browse ${props.linkObject.text.toLowerCase()} posts with photos and quick summaries in Northwest Arkansas.`;

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "0 !important",
      }}
    >
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonicalUrl(pathname)} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl(pathname)} />
      </Helmet>

      <Paper
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "4rem",
        }}
        elevation={2}
      >
        <Paper
          alt={props.linkObject.ctaAltText}
          component="img"
          src={`${props.linkObject.ctaImagePath}`}
          sx={{ width: "100%", marginBottom: "1rem" }}
          elevation={0}
        ></Paper>
      </Paper>
      <Posts posts={filteredPosts} />
    </Container>
  );
}
